import { useContext } from 'react';
import BPHeader from './BPHeader';
import BPFooter from './BPFooter';

import { BusinessPartnerContext } from './BusinessPartnerCard';
import BPSection from './BPSection';
import { SECTIONS } from './utils';

const BPBillingDetails = () => {
  const { localBPData, isEditing, handleOnChange, handleBillableSettingsUnitChange, dropdownValues, errors } =
    useContext(BusinessPartnerContext);

  return (
    <>
      <section className="bp-billingdetails">
        <BPHeader />
        <BPSection
          sections={SECTIONS['bp-billingdetails']}
          isEditing={isEditing}
          localBPData={localBPData}
          dropdownValues={dropdownValues}
          errors={errors}
          handleOnChange={handleOnChange}
          handleBillableSettingsUnitChange={handleBillableSettingsUnitChange}
        />
      </section>
      <BPFooter />
    </>
  );
};

export default BPBillingDetails;
